/* tslint:disable */
/* eslint-disable */
export enum BankStatementCommunicationMethod {
  Email = 'Email',
  Sms = 'Sms'
}
